"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionManagerUtils = void 0;
const InteractionData_1 = require("../InteractionData");
class InteractionManagerUtils {
    /**
     * Apply interaction effects to node and grouped nodes
     */
    static applyInteractionEffects(node, groupedNodes, interactionEffect, interactionEffectUtils) {
        const groupTokens = [];
        let token;
        if (interactionEffect) {
            token = interactionEffectUtils.applyInteractionEffect(node, interactionEffect);
            if (groupedNodes) {
                groupedNodes.forEach((n) => groupTokens.push(interactionEffectUtils.applyInteractionEffect(n, interactionEffect)));
            }
        }
        return { token, groupTokens };
    }
    /**
     * Common filter implementation
     */
    static createInteractionFilter(interactionType, managerId, targetStates) {
        return (interactionState) => {
            if (targetStates.includes(interactionState)) {
                return (node) => {
                    return !!this.getInteractionData(node, false, managerId, interactionType);
                };
            }
            return (node) => false;
        };
    }
    /**
     * Common getInteractionData implementation
     */
    static getInteractionData(node, restrictions, managerId, interactionType) {
        for (let i = 0; i < node.data.length; i++) {
            if (node.data[i] instanceof InteractionData_1.InteractionData) {
                const data = node.data[i];
                if (data.interactionTypes[interactionType] !== true)
                    continue;
                if (restrictions) {
                    if (data.restrictedManagers.length === 0 ||
                        data.restrictedManagers.includes(managerId))
                        return data;
                }
                else {
                    return data;
                }
            }
        }
    }
    /**
     * Remove interaction effects from node and grouped nodes
     */
    static removeInteractionEffects(node, groupedNodes, token, groupTokens, interactionEffectUtils) {
        if (token) {
            interactionEffectUtils.removeInteractionEffect(node, token);
            if (groupedNodes) {
                groupedNodes.forEach((n, i) => interactionEffectUtils.removeInteractionEffect(n, groupTokens[i]));
            }
        }
    }
    /**
     * Update viewport for node and grouped nodes
     */
    static updateViewport(viewport, node, groupedNodes) {
        viewport.updateNode(node);
        if (groupedNodes) {
            groupedNodes.forEach((n) => viewport.updateNode(n));
        }
        viewport.render();
    }
    /**
     * Validates restriction manager and logs warning if not set
     */
    static validateRestrictionManager(restrictionManager, logger) {
        if (!restrictionManager) {
            logger.warn("The interaction manager does not belong to an interaction engine. Please add it to one first.");
            return false;
        }
        return true;
    }
    /**
     * Validates viewport and logs warning if not set
     */
    static validateViewport(viewport, logger) {
        if (!viewport) {
            logger.warn("The interaction manager does not belong to an interaction engine. Please add it to one first.");
            return false;
        }
        return true;
    }
}
exports.InteractionManagerUtils = InteractionManagerUtils;
//# sourceMappingURL=InteractionManagerUtils.js.map